/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelOrderPayablesProfileLookup.ts    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/order-payables-profile-lookup";

export class AutogenModelOrderPayablesProfileLookup<RowType extends ModelRow> extends Endpoint<RowType, RowOrderPayablesProfileLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowOrderPayablesProfileLookup extends ModelRow<RowOrderPayablesProfileLookupFields> {
	constructor(values?: Partial<RowOrderPayablesProfileLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowOrderPayablesProfileLookupFields {
	bo_reason_code_exclude: string;
	company_id: string;
	cutoff_date: string;
	departments: string;
	departments_exclude: string;
	descr: string;
	has_inv_recd_date: string;
	id: string;
	payee_ids: string;
	payee_ids_exclude: string;
	payee_status: string;
	payment_method: string;
	payment_recipient: string;
	show_frozen_payables: string;
	start_date: string;
}

